import React from "react";
import { ChevronRight } from "lucide-react";

const FaqSection = ({ id = "faq-preview", eyebrow, title, intro, faqs, pageLink }) => {
  return (
    <section
      id={id}
      className="py-24 bg-gradient-to-b from-zinc-950 via-black to-zinc-950 text-white"
    >
      <div className="max-w-screen-xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-10 items-start">
          <div>
            <p className="text-xs tracking-[0.35em] uppercase text-red-500 mb-4">
              {eyebrow}
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold mb-5">{title}</h2>
            <p className="text-white/70 text-lg leading-relaxed max-w-2xl">
              {intro}
            </p>
            {pageLink ? (
              <a
                href={pageLink.href}
                className="inline-flex items-center gap-2 mt-8 text-sm font-medium tracking-[0.18em] uppercase text-red-400 hover:text-white transition-colors duration-300"
              >
                {pageLink.label}
                <ChevronRight className="w-4 h-4" />
              </a>
            ) : null}
          </div>

          <div className="space-y-4">
            {faqs.map((faq) => (
              <article
                key={faq.question}
                className="border border-white/15 bg-white/[0.03] p-6 lg:p-7"
              >
                <h3 className="text-xl font-semibold text-white mb-3">
                  {faq.question}
                </h3>
                <p className="text-white/70 leading-relaxed">{faq.answer}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
